import { useTimezoneSelect, allTimezones as timezones } from 'react-timezone-select';

export const useTimezone = () => {
  const timezoneData = useTimezoneSelect({ labelStyle: 'original', timezones });

  return timezoneData;
};
